import { useEffect, useState } from "react";
import { Button, Col, Image, message, Row, Typography } from "antd";
import { useSelector } from "react-redux";
import { ErrorMessage } from '@hookform/error-message';
import { useFormContext } from "react-hook-form";
import {
  selectIsUpdateProduct,
  selectProductForUpdate,
} from "../../../../redux";
import { IProducts } from "../../../../redux/@types";
import {
  InputHTML,
  InputNumber,
  InputSelect,
  InputSelectTree,
  InputText,
} from "../../../../shared/components";
import { PropsArrCategoriesRes, useProductModal, useProducts } from "../../hooks";
import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import Upload from "../../../../shared/components/ui/inputs/Upload";

const { Title } = Typography;

export const ProductsForm = () => {
  const isUpdateProducts = useSelector(selectIsUpdateProduct);
  const updateProducts = useSelector(selectProductForUpdate);

  const [isValidate, setIsValidate] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsValidate(!isValidate);
    }, 1500);
  }, []);

  const { isLoading, onSubmitCreateOrUpdate } = useProducts();

  const { arrBrands, arrCategories, arrTax } = useProductModal();

  const generateNestedCategories = (categories:PropsArrCategoriesRes[]):any =>{
    return categories.map((item) => ({
      title: item.name,
      value: item.id.toString(),
      ...(item.children && { children: generateNestedCategories(item.children) }),
    }));
  }

  const { control, handleSubmit: onSubmit, watch, setValue, formState: { errors } } = useFormContext<IProducts>();

  const premium = watch('premium');
  const description = watch('description');
  const unit_measure = watch('unit_measure');
  const type_of_cut_image_path = watch('type_of_cut_image_path');
  // const preparation_tutorial_video_path = watch('preparation_tutorial_video_path');
  const recommendations_image_cover_path = watch('recommendations_image_cover_path');
  const unitMeasureNormalized = (unit_measure || '').toString().trim().toUpperCase();
  const isKgUnit =
    unitMeasureNormalized === 'KG' || unitMeasureNormalized.startsWith('KILO');

  return (
    <>
      {isValidate &&
        <Row justify="start">
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Nombre:
            </Title>
            <InputText
              placeHolder="Producto ideal"
              name="name"
              control={control}
            />
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Código:
            </Title>
            <InputText placeHolder="123ABC" name="code" control={control} />
          </Col>
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "2.6px" }} level={2}>
              Categorías
            </Title>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Categoría principal:
            </Title>
            <InputSelectTree
            name="category_id"
            control={control}
            dataOptions={generateNestedCategories(arrCategories)}
            label="Categoría principal"
            />
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Marca:
            </Title>
            <InputSelect
              name="brand_id"
              control={control}
              dataOptions={arrBrands.map((item) => ({
                title: item.name,
                value: item.id.toString(),
              }))}
              label="Marca insignia"
              showSearch
            />
          </Col>
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "2.1px" }} level={2}>
              Precios
            </Title>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Precio sin IVA
            </Title>
            <InputNumber
              placeHolder="0"
              name="price"
              control={control}
              min
            />
          </Col>
          {isUpdateProducts && (
            <Col
              span={12}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Precio con IVA
              </Title>
              <InputNumber
                placeHolder="0"
                name="price_with_tax"
                control={control}
                min
                isDisable
              />
            </Col>
          )}
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Precio en descuento sin IVA
            </Title>
            <InputNumber
              placeHolder="0"
              name="discount_price"
              control={control}
              min
            />
          </Col>
          {isUpdateProducts && (
            <Col
              span={12}
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Precio en descuento con IVA
              </Title>
              <InputNumber
                placeHolder="0"
                name="discount_price_whit_tax"
                control={control}
                min
                isDisable
              />
            </Col>
          )}
          {
            arrTax && (
              <Col
                span={12}
                style={{
                  display: "flex",
                  marginTop: "10px",
                  padding: 5,
                  justifyContent: "center",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <Title style={{ marginBottom: "1.5px" }} level={5}>
                  IVA %:
                </Title>
                <InputSelect
                  name="tax_rule_id"
                  control={control}
                  defaultValue={arrTax[0]?.id!.toString()}
                  dataOptions={arrTax.map((item) => ({
                    title: item.name,
                    value: item.id.toString(),
                  }))}
                  label="IVA %"
                />
              </Col>
            )
          }


       
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          />
            
          <Title style={{ marginBottom: "2.1px" }} level={2}>
              Cashback
            </Title>
                        <Col
              span={12}
              style={{
                display: "flex",
                marginTop: "10px",
                padding: 5,
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Estado:
              </Title>
              <InputSelect
                name="cashback_status"
                control={control}
                dataOptions={[
                  { title: "Global", value: "global" },
                  { title: "Specific Percentage", value: "specific" },
                  { title: "Inactivo", value: "inactive" },
                ]}
                label="Cashback Status"
              />
            </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Cashback Specific Percentage:
            </Title>
            <InputNumber
              placeHolder=""
              name="cashback_specific_percentage"
              control={control}
              min
            />
          </Col>

          
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "2.1px" }} level={4}>
              Cantidades
            </Title>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Cantidad disponible:
            </Title>
            <InputNumber
              placeHolder="12345"
              name="quantity"
              control={control}
              min
            />
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Unidad de medida:
            </Title>
            <InputSelect
              name="unit_measure"
              control={control}
              dataOptions={[
                { title: "Gramos (GR)", value: "GR" },
                { title: "Kilogramos (KG)", value: "KG" },
                { title: "Unidades (UN)", value: "UN" },
                { title: "Libras (LB)", value: "LB" },
              ]}
              label="Unidad de medida"
            />
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              {isKgUnit ? "Peso aproximado (kg):" : "Gramaje aproximado (g):"}
            </Title>
            <InputNumber
              placeHolder={isKgUnit ? "Ej: 1.3" : "Ej: 14.9, 500, 1000"}
              name="approximate_grams"
              control={control}
              min
            />
            <span style={{ fontSize: "0.75rem", color: "#888", marginTop: 4 }}>
              {isKgUnit
                ? "Peso en kilogramos por unidad (ej: 1.3). La app lo muestra en kg y calcula el precio por kilo."
                : "Peso en gramos por unidad (acepta decimales). La app calcula el precio por gramo a partir de este valor."}
            </span>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Es producto fresco:
            </Title>
            <InputSelect
              name="is_fresh"
              control={control}
              dataOptions={[
                { title: "Sí", value: "true" },
                { title: "No", value: "false" },
              ]}
              label="Producto fresco por peso"
            />
            <span style={{ fontSize: "0.75rem", color: "#888", marginTop: 4 }}>
              Muestra el aviso de peso variable y reembolsos en la app.
            </span>
          </Col>
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "2.1px" }} level={2}>
              Peso y medidas
            </Title>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Peso:
            </Title>
            <InputNumber
              placeHolder="Peso en kg"
              name="weight"
              control={control}
              min
            />
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Alto:
            </Title>
            <InputNumber
              placeHolder="Alto en cm"
              name="heigh"
              control={control}
              min
            />
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Ancho:
            </Title>
            <InputNumber
              placeHolder="Ancho en cm"
              name="width"
              control={control}
              min
            />
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Largo:
            </Title>
            <InputNumber
              placeHolder="Largo en cm"
              name="long"
              control={control}
              min
            />
          </Col>
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "2.1px" }} level={2}>
              Descripción
            </Title>
          </Col>
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Descripción:
            </Title>
            {isUpdateProducts && description ? (
              <InputHTML
                placeHolder="Es un producto muy optimo para..."
                name="description"
                control={control}
                isUpdating
              />
            ) : (
              <InputHTML
                placeHolder="Es un producto muy optimo para..."
                name="description"
                control={control}
              />
            )}
          </Col>
          {/* <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Composición y cuidado:
            </Title>
            {isUpdateProducts ? (
              <InputHTML
                placeHolder="Lorem Ipsum is simply dummy text of the printing..."
                name="user_guide_composition"
                control={control}
                isUpdating
              />
            ) : (
              <InputHTML
                placeHolder="Lorem Ipsum is simply dummy text of the printing..."
                name="user_guide_composition"
                control={control}
              />
            )}
          </Col>
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Guía de uso:
            </Title>
            {isUpdateProducts ? (
              <InputHTML
                placeHolder="Lorem Ipsum is simply dummy text of the printing..."
                name="user_guide_care"
                control={control}
                isUpdating
              />
            ) : (
              <InputHTML
                placeHolder="Lorem Ipsum is simply dummy text of the printing..."
                name="user_guide_care"
                control={control}
              />
            )}
          </Col> */}
          {isUpdateProducts && (
            <Col
              span={12}
              style={{
                display: "flex",
                marginTop: "10px",
                padding: 5,
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Title style={{ marginBottom: "1.5px" }} level={5}>
                Estado:
              </Title>
              <InputSelect
                name="status"
                control={control}
                dataOptions={[
                  { title: "Activo", value: "active" },
                  { title: "Inactivo", value: "inactive" },
                ]}
                label="Estado"
              />
            </Col>
          )}
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "2.1px" }} level={2}>
              Posición
            </Title>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Posición en lo más vendido:
            </Title>
            <InputNumber
              //   stringMode={true}
              placeHolder="8"
              name="position_more_sales"
              control={control}
              min
            />
          </Col>
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "2.1px" }} level={2}>
              Corte premium
            </Title>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              marginTop: "10px",
              padding: 5,
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Title style={{ marginBottom: "1.5px" }} level={5}>
              Es un corte premium:
            </Title>
            <InputSelect
              name="premium"
              control={control}
              dataOptions={[
                { title: "Si", value: "true" },
                { title: "No", value: "false" },
              ]}
              label="Selecciona si el producto es un corte premium"
            />
          </Col>
          {
            premium === "true" && (
              <>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <Title style={{ marginBottom: "1.5px" }} level={5}>
                    Tutorial de preparación:
                  </Title>
                  <InputText
                      placeHolder="https://www.youtube.com/watch?v=FlsCjmMhFmw"
                      name="preparation_tutorial_video_path"
                      control={control}
                    />
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                <Title style={{ marginBottom: "1.5px" }} level={5}>
                  Tipo de corte:
                </Title>
                {type_of_cut_image_path ? (
                  <img
                    src={`${PATH_S3_BUCKET}/${type_of_cut_image_path}`}
                    alt="type_of_cut_image_path"
                    style={{
                      marginBottom: "7px",
                      width: "100%",
                      height: "100%",
                      maxWidth: "250px",
                      maxHeight: "250px",
                    }}
                  />
                ) : (
                  <img
                    style={{
                      marginBottom: "7px",
                      maxWidth: "250px",
                      maxHeight: "250px",
                    }}
                    alt="error"
                    src="data:image/png;base64,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"
                  />
                  )}
                  <Upload
                    filePath="type_of_cut_image_path"
                    onUploadedFile={(files) => {
                      // console.log({ files });
                      const file = files[0];
                      setValue("type_of_cut_image_path", file.fileKey);
                      message.success("Se ha actualizado la imagen del tipo de corte");
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="type_of_cut_image_path"
                    render={({ message }) =>{
                      return(
                        <>{
                          errors.type_of_cut_image_path && (
                            <span style={{ color:  "#ff4d4f"}}>{message}</span>
                          )
                        }</>
                      )
                    }}
                  />
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <Title style={{ marginBottom: "1.5px" }} level={5}>
                    Imagen de recomendaciones:
                  </Title>
                  {recommendations_image_cover_path ? (
                    <img
                      src={`${PATH_S3_BUCKET}/${recommendations_image_cover_path}`}
                      alt="recommendations_image_cover_path"
                      style={{
                        marginBottom: "7px",
                        width: "100%",
                        height: "100%",
                        maxWidth: "250px",
                        maxHeight: "250px",
                      }}
                    />
                  ) : (
                    <img
                      style={{
                        marginBottom: "7px",
                        maxWidth: "250px",
                        maxHeight: "250px",
                      }}
                      alt="error"
                      src="data:image/png;base64,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"
                    />
                  )}
                    <Upload
                      filePath="recommendations_image_cover_path"
                      onUploadedFile={(files) => {
                        // console.log({ files });
                        const file = files[0];
                        setValue("recommendations_image_cover_path", file.fileKey);
                        message.success("Se ha actualizado la imagen de recomendaciones");
                      }}
                    />
                    <ErrorMessage
                    errors={errors}
                    name="recommendations_image_cover_path"
                    render={({ message }) =>{
                      return(
                        <>{
                          errors.recommendations_image_cover_path && (
                            <span style={{ color:  "#ff4d4f"}}>{message}</span>
                          )
                        }</>
                      )
                    }}
                  />
                </Col>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    padding: 5,
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <Title style={{ marginBottom: "1.5px" }} level={5}>
                    Recomendaciones:
                  </Title>
                  {isUpdateProducts ? (
                    <InputHTML
                      placeHolder="Es recomendado que este tipo de carnes se prepare con..."
                      name="recommendations_text_html"
                      control={control}
                      isUpdating
                    />
                  ) : (
                    <InputHTML
                      placeHolder="Es recomendado que este tipo de carnes se prepare con..."
                      name="recommendations_text_html"
                      control={control}
                    />
                  )}
                </Col>
              </>
            )
          }
          <Col
            span={24}
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
              alignItems: "flex-end",
              flexDirection: "column",
            }}
          >
            <Button
              style={{
                marginTop: 10,
              }}
              type="primary"
              shape="round"
              size="large"
              onClick={onSubmit(onSubmitCreateOrUpdate)}
              loading={isLoading}
            >
              {isUpdateProducts ? "Actualizar información" : "Crear producto"}
            </Button>
          </Col>
        </Row>
      }
    </>
  );
};